export const MODAL_TEXT = "text-base md:text-lg";

export const LABEL_TEXT =
  "text-sm md:text-base font-semibold tracking-wide text-slate-500 uppercase";

export const FIELD_CLASS =
  "h-11 md:h-12 px-4 text-base md:text-lg rounded-xl border border-slate-300 shadow-sm focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900/10 disabled:bg-slate-50";

export const BTN_BASE =
  "h-11 md:h-12 px-6 text-base md:text-lg rounded-full font-semibold whitespace-nowrap transition";

export const BTN_OUTLINE = `${BTN_BASE} border border-slate-300 text-slate-700 hover:border-slate-400 disabled:opacity-50`;

export const BTN_PRIMARY = `${BTN_BASE} bg-rose-500 text-white hover:bg-rose-600 disabled:opacity-60 disabled:cursor-not-allowed`;

export const BTN_DANGER = `${BTN_BASE} bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-60 disabled:cursor-not-allowed`;

export const TAB_BASE =
  "h-10 md:h-11 px-4 md:px-5 rounded-full text-sm md:text-base font-semibold transition";

export const TAB_ACTIVE = "bg-rose-500 text-white";

export const TAB_INACTIVE =
  "border border-slate-300 text-slate-700 hover:border-slate-400";
